import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { IGetCustomerCkycResponse } from 'Models/RequestModels/Life/CKyc'
export interface ISuitabilityDataStoreValues {
  currentStep: number
  selectedGoals: {
    code: string
    value: string
  }[]
  other: Record<string, string>
  goalsOrder: Record<string, number>
  fetchDataFromCkycLA: boolean
  fetchDataFromCkycPA: boolean
  ckycData?: IGetCustomerCkycResponse
  isCkycDataChange: boolean
  // goal_amounts: any
}

const initialState: ISuitabilityDataStoreValues = {
  currentStep: 1,
  selectedGoals: [],
  other: {},
  goalsOrder: {},
  fetchDataFromCkycLA: false,
  fetchDataFromCkycPA: false,
  isCkycDataChange: false,
  // goal_amounts: {},
}

const suitabilityDataSlice = createSlice({
  name: 'suitabilityDataSlice',
  initialState: initialState,
  reducers: {
    setCurrentStep: (state, action: PayloadAction<number>) => {
      state.currentStep = action.payload
    },
    setSelectedGoals: (
      state,
      action: PayloadAction<
        {
          code: string
          value: string
        }[]
      >,
    ) => {
      state.selectedGoals = action.payload
    },
    updateSuitabilityOtherData: (state, action: PayloadAction<any>) => {
      state.other = action.payload
    },
    updateSuitabilityGoalsOrder: (state, action: PayloadAction<Record<string, number>>) => {
      state.goalsOrder = action.payload
    },
    updateFetchDataFromCkycLA: (state, action: PayloadAction<boolean>) => {
      state.fetchDataFromCkycLA = action.payload
    },
    updateFetchDataFromCkycPA: (state, action: PayloadAction<boolean>) => {
      state.fetchDataFromCkycPA = action.payload
    },
    updateCkycData: (state, action: PayloadAction<IGetCustomerCkycResponse>) => {
      state.ckycData = action.payload
    },
    updateIsCkycDataChange: (state, action: PayloadAction<boolean>) => {
      state.isCkycDataChange = action.payload
    },
    // updateSuitabilityGoalAmounts: (state, action: PayloadAction<any>) => {
    //   state.goal_amounts = action.payload
    // },
    updateAllSuitabilityData: (state, action: PayloadAction<ISuitabilityDataStoreValues>) => {
      const {
        currentStep,
        selectedGoals,
        other,
        goalsOrder,
        fetchDataFromCkycLA,
        fetchDataFromCkycPA,
        ckycData,
        isCkycDataChange,
      } = action.payload
      if (currentStep !== undefined) {
        state.currentStep = currentStep
      }
      if (selectedGoals !== undefined) {
        state.selectedGoals = selectedGoals
      }
      if (other !== undefined) {
        state.other = other
      }
      if (goalsOrder !== undefined) {
        state.goalsOrder = goalsOrder
      }
      if (fetchDataFromCkycLA !== undefined) {
        state.fetchDataFromCkycLA = fetchDataFromCkycLA
      }
      if (fetchDataFromCkycPA !== undefined) {
        state.fetchDataFromCkycPA = fetchDataFromCkycPA
      }
      if (ckycData !== undefined) {
        state.ckycData = ckycData
      }
      if (isCkycDataChange !== undefined) {
        state.isCkycDataChange = isCkycDataChange
      }
    },
    resetAllSuitabilityData: () => initialState,
  },
})

const { reducer } = suitabilityDataSlice

const {
  updateSuitabilityOtherData,
  updateSuitabilityGoalsOrder,
  // updateSuitabilityGoalAmounts,
  setCurrentStep,
  setSelectedGoals,
  updateFetchDataFromCkycLA,
  updateFetchDataFromCkycPA,
  updateCkycData,
  updateIsCkycDataChange,
  updateAllSuitabilityData,
  resetAllSuitabilityData,
} = suitabilityDataSlice.actions

export {
  reducer as suitabilityDataReducer,
  updateSuitabilityOtherData,
  updateSuitabilityGoalsOrder,
  // updateSuitabilityGoalAmounts,
  setCurrentStep,
  setSelectedGoals,
  updateFetchDataFromCkycLA,
  updateFetchDataFromCkycPA,
  updateCkycData,
  updateIsCkycDataChange,
  updateAllSuitabilityData,
  resetAllSuitabilityData,
}
